import React from "react";
import { Table, message, Empty, InputNumber, Button, Space } from "antd";
import { Card, Row, Col } from "reactstrap";
import { PanelHeader } from "components";
import axios from "axios";
import BillsDrawer from "./components/BillsDrawer";

class BillsReturned extends React.Component {
  constructor(props) {
    super(props);
    if (!props.userData.isBillingDepartmentN1()) this.redirectTo("/dashboard");
    this.state = {
      customersReturned: [],
      minCount: 0,
      maxCount: 100,
      loading: false,
      tempMinCount: null,
      tempMaxCount: null,
      openBillsDrawer: false,
    };
  }

  componentDidMount() {
    this.listCustomersReturnedSummary();
  }

  listCustomersReturnedSummary = async () => {
    const { minCount, maxCount } = this.state;
    this.setState({ loading: true });
    try {
      const csrfToken = localStorage.getItem("token");
      const response = await axios.post(
        "https://oficina.nadunet.es/api/rest/nadunet_billing_resources/get_customers_returned_summary",
        {
          verify_token: "5yE598k3QK2frjmak8RVIzWfRCsZGk09vHY2QD6VotCo5CoLdmokyUO9FrXLUFjb",
          min_count: minCount,
          max_count: maxCount,
        },
        {
          headers: {
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.data && response.data.ok) {
        this.setState({ customersReturned: response.data.data, loading: false });
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Error fetching sepa info:", error);
      message.error("Error al obtener la información SEPA");
      this.setState({ loading: false });
    }
  };

  handleFilterChange = (key, value) => {
    this.setState({ [key]: value });
  };

  handleApplyFilter = () => {
    const { tempMinCount, tempMaxCount } = this.state;
    this.setState(
      { minCount: tempMinCount, maxCount: tempMaxCount },
      this.listCustomersReturnedSummary
    );
  };

  renderTableTitle = () => {
    const { tempMinCount, tempMaxCount, loading } = this.state;
    return (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", textAlign: "center" }}>
        <h3 style={{ margin: 0 }}>Morosos</h3>
        <Space>
          <span style={{ fontSize: 14 }}>Facturas entre</span>
          <InputNumber
            min={0}
            value={tempMinCount}
            onChange={value => this.handleFilterChange("tempMinCount", value)}
            placeholder="Mín."
            style={{ width: 80 }}
          />
          <span style={{ fontSize: 14 }}>y</span>
          <InputNumber
            min={0}
            value={tempMaxCount}
            onChange={value => this.handleFilterChange("tempMaxCount", value)}
            placeholder="Máx."
            style={{ width: 80 }}
          />
          <Button type="primary" onClick={this.handleApplyFilter} loading={loading}>
            Filtrar
          </Button>
        </Space>
      </div>
    );
  };

  render() {
    const { customersReturned, loading, openBillsDrawer } = this.state;
    return (
      <div>
        <PanelHeader size="sm" />
        <BillsDrawer open={openBillsDrawer}
          onClose={() => this.setState({ openBillsDrawer: false })} />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card style={{ padding: 10 }}>
                <Table
                  title={this.renderTableTitle}
                  dataSource={customersReturned}
                  loading={loading}
                  columns={[
                    {
                      title: "Nombre",
                      key: "name",
                      render: (record) => (
                        <a
                          target="_blank"
                          href={`https://oficina.nadunet.es/clientes/fichas/${record.id}`}
                        >
                          {record.name}
                        </a>
                      ),
                    },
                    {
                      title: "Estado",
                      dataIndex: "status",
                      key: "status",
                      align: "center",
                    },
                    {
                      title: "Fecha última",
                      dataIndex: "last_return",
                      key: "last_return",
                      align: "center",
                    },
                    {
                      title: "Total de facturas",
                      dataIndex: "bills_count",
                      key: "bills_count",
                      align: "center",
                      sorter: (a, b) => a.bills_count - b.bills_count,
                      render: (text) => (
                        <Button style={{ fontWeight: "bold" }} onClick={() => this.setState({ openBillsDrawer: true })}>{text}</Button>
                      ),
                    },
                    {
                      title: "Total",
                      dataIndex: "total_text",
                      key: "total_text",
                      align: "center",
                      sorter: (a, b) => a.total - b.total,
                    },
                  ]}
                  rowKey="id"
                  scroll={{ x: "max-content" }}
                  locale={{
                    filterConfirm: "Vale",
                    filterReset: "Restablecer",
                    emptyText: (
                      <Empty
                        description={"No hay morosos"}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default BillsReturned;



// WEBPACK FOOTER //
// ./src/views/Bills/BillsReturned.jsx